import axios from 'axios';

export const fetchSearchData = async (endpoint, formData = '') => {
  const config = {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  };

  // can't use post request in local env, so we use get instead while developing
  const response =
    process.env.NODE_ENV !== 'production'
      ? await axios.get(endpoint)
      : await axios.post(endpoint, formData, config);

  return response.data.content.colPos0[0].content.data;
};

export const replaceUrl = formData => {
  const searchParams = new URLSearchParams(formData).toString();
  const searchString = searchParams !== '' ? '?' + searchParams : '';
  window.history.replaceState(
    {},
    '',
    `${window.location.pathname}${searchString}`
  );
};
